import styled from "styled-components";

export const CardContainer = styled.div.attrs({})`
  ${p => p.$fullWidth ? 'box-sizing: border-box;' : ''}
  width: ${p => p.$fullWidth ? '100%' : '300px'};
  min-width: ${p => p.$fullWidth ? '0' : '300px'};
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 24px;
  background:
    linear-gradient(180deg, ${p => p.theme.palette.colors.surfaceElevatedSoft} 0%, ${p => p.theme.palette.colors.surfaceElevatedStrong} 100%);
  cursor: pointer;
  padding: 16px;
  position: relative;
  overflow: hidden;
  box-shadow:
    0 24px 56px ${p => p.theme.palette.colors.shadowStrong},
    inset 0 1px 0 ${p => p.theme.palette.colors.borderSoft};
  transition: transform 0.28s ease, box-shadow 0.28s ease, border-color 0.28s ease;

  &:focus-visible {
    outline: 2px solid ${p => p.theme.palette.blue.main};
    outline-offset: 3px;
  }

  &:hover {
    transform: translateY(-6px);
    box-shadow:
      0 30px 64px ${p => p.theme.palette.colors.shadowLift},
      inset 0 1px 0 ${p => p.theme.palette.colors.borderStrong};
  }

  @media (max-width: 991px) {
      width: ${p => p.$fullWidth ? '100%' : 'min(320px, 100%)'};
      min-width: ${p => p.$fullWidth ? '0' : 'min(320px, 100%)'};
  }
`;


export const CardImg = styled.div.attrs({})`
  width: 100%;
  aspect-ratio: ${p => p.ration ? "32 / 24" : "16 / 10"};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: ${p => p.$supportVideo ? '0' : '266px'};
  border-radius: 18px;
  overflow: hidden;
  background:
    radial-gradient(circle at top left, ${p => p.theme.palette.colors.shellGradientStart} 0%, ${p => p.theme.palette.colors.backgroundTransparent} 38%),
    ${p => p.theme.palette.colors.surface};
  box-shadow:
    inset 0 1px 0 ${p => p.theme.palette.colors.borderSoft},
    0 16px 36px ${p => p.theme.palette.colors.shadowStrong};
  position: relative;

  @media (max-width: 991px) {
    width: 100%;
    min-height: unset;
  }
`;

export const PlayOverlay = styled.span.attrs({})`
  position: absolute;
  inset: 50% auto auto 50%;
  z-index: 2;
  width: 58px;
  height: 58px;
  border: 1px solid ${p => p.theme.palette.colors.mediaControlBorder};
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${p => p.theme.palette.colors.mediaControlBackground};
  box-shadow: 0 12px 28px ${p => p.theme.palette.colors.shadowStrong};
  transform: translate(-50%, -50%);
  transition: transform 0.24s ease, background 0.24s ease, border-color 0.24s ease;

  ${CardContainer}:hover & {
    border-color: ${p => p.theme.palette.colors.mediaControlBorderStrong};
    background: ${p => p.theme.palette.colors.mediaControlBackgroundStrong};
    transform: translate(-50%, -50%) scale(1.08);
  }
`;

export const FavoriteAction = styled.button.attrs({
  type: 'button',
})`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${p => p.theme.palette.colors.surfaceElevatedSoft};
  box-shadow: 0 10px 24px ${p => p.theme.palette.colors.shadowStrong};
  cursor: pointer;
`;

export const ImgCover = styled.img.attrs({})`
  width: 100%;
  height: 100%;
  max-height: 100%;
  object-fit: cover;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-touch-callout: none;
  pointer-events: none;
  transition: transform 0.32s ease;

  ${CardContainer}:hover & {
    transform: scale(1.04);
  }
`;


export const Item = styled.div.attrs({})`
  height: 56px;
`;
export const CardProgress = styled.div.attrs({})`
  width: 100%;
  height: 6px;
  background: ${p => p.theme.palette.colors.white};
`;

export const CardProgressIn = styled.div.attrs({})`
  width: ${({ progress }) => progress ? `${progress}%` : "0%"};
  height: 6px;
  background: ${({ theme }) => theme.red || "red"};
`;

export const CardTitle = styled.span.attrs({})`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-family: Gilroy;
  font-size: 24px;
  font-weight: ${p => p.light ? 500 : 700};
  line-height: 1.16;
  letter-spacing: -0.03em;
  color: ${p => p.theme.palette.colors.text};
`;

export const CardDescription = styled.p.attrs({})`
  display: -webkit-box;
  overflow: hidden;
  margin: 0;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  font-family: Poppins;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.55;
  color: ${p => p.theme.palette.colors.muted};
`;

export const CardTextBlock = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CardEyebrow = styled.div.attrs({})`
  font-family: Poppins;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.45;
  letter-spacing: 0.12em;
  color: ${p => p.theme.palette.colors.subdued};
  text-transform: uppercase;
`;

export const CardMeta = styled.div.attrs({})`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const CardUserName = styled.div.attrs({})`
  width: fit-content;
  min-height: 24px;
  border-radius: 999px;
  padding: 4px 10px;
  font-family: Poppins;
  font-size: 13px;
  line-height: 1.4;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: ${p => p.theme.palette.colors.text};
  background: ${p => p.theme.palette.colors.badgeMuted};
`;

export const FileFallback = styled.div.attrs({})`
  width: 100%;
  height: 100%;
  min-height: 160px;
  flex-direction: column;
  gap: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-touch-callout: none;
  pointer-events: none;
  border-radius: 8px;
  background: ${p => p.theme.palette.colors.lightBlue};
  color: ${p => p.theme.palette.colors.black};
  font-family: Lato;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
`;
export const ShareContainer = styled.div.attrs({})`
  margin-top: -2px;
  display: flex;
  align-items: center;
  min-width: 0;
`;
